export const allCompanyTypes = [
  'builder',
  'glazier',
  'landscaper',
  'renewables',
  'flooring',
  'kitchen',
  'retail',
] as const

export type CompanyType = (typeof allCompanyTypes)[number]
